import React, { useState } from 'react';
import styles from './styles.module.scss';
import { format } from 'date-fns';
import MeetingPopupDialog from '../../../components/meetingPopupDialog';
import { dateFormatUTCtoLocal, formatUTCtoUTCDateMnameYearTime } from '../../../shared/dateFunction';

const WebinarDetails = (props) => {
    const { data } = props;
    const [isDialogOpen, setDialogOpen] = useState(false);

    if (!data) return null;

    const {
        name,
        description,
        onDateTime,
        meetingTime,
        meetingLink,
        Language,
        Counselor
    } = data;

    const handleStartMeeting = () => {
        setDialogOpen(false);
        if (meetingLink) {
            window.open(meetingLink, '_blank');
        }
    };

    const mentorInstructionsJson = [
        <>After clicking “Start”, you must click “Join” on the Google Meet page to begin the session.</>,
    ];

    return (
        <div className={styles.webinar_container}>
            <div className={styles.left_section}>
                <h1 className={styles.title}>{name}</h1>
                <p className={styles.description}>{description}</p>

                <div className={styles.details_box}>
                    <p><strong>Date:</strong> {formatUTCtoUTCDateMnameYearTime(onDateTime)}</p>
                    <p><strong>Duration:</strong> {meetingTime} Minutes</p>
                    <p><strong>Language:</strong> {Language?.name}</p>
                    {meetingLink && (
                        <p>
                            <strong>Meeting Link:</strong>{' '}
                            <a href={meetingLink} target="_blank" rel="noopener noreferrer">
                                {meetingLink}
                            </a>
                        </p>
                    )}
                </div>

                <button
                    className={styles.register_btn}
                    onClick={() => setDialogOpen(true)}
                >
                    Start Meeting
                </button>
            </div>

            {/* Counselor Info Section */}
            <div
                className={`${styles.instructor_wrapper} ${Counselor?.length === 1 ? styles.center_single : styles.grid_multiple
                    }`}
            >
                {Counselor?.map((counselor, index) => (
                    <div key={index} className={styles.instructor_card}>
                        <img
                            src={counselor?.image || "https://placehold.co/600x400/png?text=Instructor+Image"}
                            alt="Counselor"
                            className={styles.instructor_img}
                        />
                        <div className={styles.instructor_info}>
                            <div>{counselor?.name}</div>
                            {counselor?.CAStatus && <p>CA {counselor?.CAStatus}</p>}
                            {counselor?.preference?.syllabus && <p>Syllabus: {counselor?.preference?.syllabus}</p>}
                            <p>Languages: {Language?.name}</p>
                        </div>
                    </div>
                ))}
            </div>

            <MeetingPopupDialog
                open={isDialogOpen}
                setOpen={setDialogOpen}
                onStartMeeting={handleStartMeeting}
                title="Before You Start"
                instructions={mentorInstructionsJson}
            />
        </div>
    );
};

export default WebinarDetails;
